<section class="w-full">
    @if(view.site) {
    <div class="w-full relative h-[400px] bg-cover  bg-no-repeat bg-center flex flex-col justify-center items-center"
        [ngStyle]="{ 'background-image': 'url(' + view.imageHref + ')' }">
        <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <h1 class="z-10 custom_font text-6xl text-white text-shadow">{{view.page?.content.name}}</h1>
    </div>

    <div class="flex justify-center items-center py-20 bg-white">
        <p class="px-15 italic text-center text-xl md:font-2xl text-primary-500 tracking-wide">
            {{view.page?.content.tagline}}</p>
    </div>

    <div class="flex justify-center items-center relative p-4 md:p-10 lg:p-10">
        <p class="w-2/3 bg-white p-6 rounded-tl-[50px] shadow-lg text-center relative" 
           [innerHTML]="view.page?.content.rawContentShort"></p>
        <div class="hidden relative w-1/3 md:flex justify-center">
            <img src="https://images.pexels.com/photos/5405596/pexels-photo-5405596.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="about us image" 
                class="md:w-64 md:h-64 lg:w-80 lg:h-80 object-cover rounded-br-[50px] shadow-lg">
        </div>
    </div>

    <!-- <section class="py-10 bg-white">
        <div class="container mx-auto text-center">
            <h2 class="text-3xl font-bold tracking-wide mb-4">Meet the Team</h2>
            <p class="text-lg mb-8">Over 30 years of experience at your service</p>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                @for(member of view.teamMembers; track member) {
                <div class="flex flex-col items-center">
                    <img src="{{member.image}}" alt="Member Profile" class="w-50 h-50 rounded-full mb-4 p-4 mx-auto">
                    <h3 class="font-semibold">{{member.name}}</h3>
                </div>
                }
            </div>
        </div>
    </section> -->
    }

    <div class="flex justify-center items-center relative p-4 md:p-10 lg:p-10">
        <div class="hidden relative w-1/3 md:flex justify-center">
            <img src="https://images.pexels.com/photos/1051075/pexels-photo-1051075.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="about us image" 
                class="md:w-64 md:h-64 lg:w-80 lg:h-80 object-cover rounded-bl-[50px] shadow-lg">
        </div>
        <p class="w-2/3 bg-white p-6 rounded-tr-[50px] shadow-lg text-center relative z-10" 
           [innerHTML]="view.page?.content.rawContent"></p>
    </div>

    <section class="bg-primary text-white py-14 px-16 text-center">
        <div class="container mx-auto flex flex-col md:flex-row items-center justify-between">
            <p class="text-2xl tracking-wider">WANT TO TALK BUSINESS? LET’S WORK TOGETHER</p>
            <div class="flex flex-row justify-center">
                <a [routerLink]="'/contact-us'"
                    class="bg-accent rounded-lg ring-primary-500 py-2 px-6 transition transition-duration: 500ms hover:text-primary hover:bg-primary-50 cursor-pointer inline-block text-center no-underline">Contact Us</a>
            </div>
        </div>
    </section>

</section>